// extracted by mini-css-extract-plugin
export var downArrow = "_7v-0";
export var infoTooltipIcon = "_7v-3";
export var label = "_7v-1";
export var optionCard = "_7v-4";
export var upArrow = "_7v-2";